/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box, Chip } from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { isLoadedQueryModified } from "./useSavedQueryState";
import { loadedQueryChipStyles, loadedQueryModifiedStyles, loadedQueryNameStyles } from "./styles";

// Names the loaded saved query, with a small "Modified" line once the page's filters differ from it.
export const SavedQueryChip = ({ adapter, filters, state }) => {
  if (!state.loadedQuery) return null;

  const { name } = state.loadedQuery;
  const isModified = isLoadedQueryModified(adapter, filters, state);

  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<BookmarkBorderIcon />}
      label={
        <React.Fragment>
          <Box component="span" sx={loadedQueryNameStyles} data-testid="saved-query-loaded-name-text">
            {name}
          </Box>
          {isModified ? (
            <Box component="span" sx={loadedQueryModifiedStyles} data-testid="saved-query-modified">
              Modified
            </Box>
          ) : null}
        </React.Fragment>
      }
      title={isModified ? `${name} - Modified` : name}
      sx={loadedQueryChipStyles}
      data-testid="saved-query-loaded-name"
    />
  );
};
